import { Story } from '../../types/story';

export const berlinUnderground: Story = {
  id: 'berlin-underground',
  title: 'Underground',
  excerpt: 'A private club in Berlin becomes the setting for an evening that pushes every boundary.',
  city: 'Berlin',
  publishDate: '2025-12-19',
  readTime: '28 min read',
  tags: ['♂♂♂', 'group', 'intense', 'club'],
  categories: ['queer', 'intense', 'adventurous'],
  intensity: 3,
  content: `The address Marcus gave me was written on a napkin, the ink already smudging from the condensation of my beer glass. He'd slid it across the table at the bar in Schöneberg with that look—the one that said he knew exactly what kind of trouble I was looking for.

"Friday night," he'd said. "Tell them Marcus sent you. And James?" He'd leaned in close. "Don't go if you're not ready. This isn't a tourist thing. This is real."

I'd spent three days thinking about it. Three days of walking around Berlin, visiting museums I didn't care about, eating currywurst I couldn't taste, all while that napkin burned a hole in my wallet. I'd come to Berlin to lose myself. To finally stop being the careful, controlled person I'd been my whole life. To find out what I actually wanted when no one was watching.

Friday night, I stood outside the building in Kreuzberg for ten minutes before I could make myself knock. The street had no name. The door had no sign. Just a number spray-painted on brick and a single red bulb above the frame.

The door opened before I could knock a second time. The bouncer was massive—shaved head, neck tattoos, arms like tree trunks. He looked me up and down with the kind of assessment that made me feel transparent.

"Name?"

"James. Marcus sent me."

He checked a list on his phone, nodded once. "ID."

I handed it over. He studied it, studied my face, handed it back.

"Phone."

"What?"

"Your phone. You get it back when you leave." He held out a hand the size of a dinner plate. "Standard practice."

I hesitated. This was it—the last moment I could turn around, go back to my hotel, pretend I'd never come here. Instead, I unlocked my phone and handed it over. He dropped it into a locked box behind him.

"Coat check is inside. Bar takes cash only. Back rooms are downstairs." He stepped aside. "Welcome to Untergrund."

The bass hit me first—a physical thing that vibrated in my chest and made my teeth ache. Then the heat. Then the smell: sweat and leather and something chemical I couldn't place. My eyes took a moment to adjust to the red light that bathed everything in a hellish glow.

The main floor was packed. Bodies moving to techno that had no melody, just rhythm and bass. Shirtless men in harnesses, leather, latex. Some in jockstraps and nothing else. The dress code here was either everything or nothing, and I was overdressed in my jeans and t-shirt.

I made my way to the bar, ordered a vodka with cash I'd withdrawn specifically for this. The bartender—topless, nipples pierced, eyes lined with black—poured a generous measure and took my money without a word.

I drank it too fast, felt the burn, ordered another.

"First time?"

I turned. The guy next to me was tall, maybe six-three, with a shaved head and a leather harness stretched across a bare, muscled chest. His arms were covered in tattoos—geometric patterns that seemed to move in the red light. He was watching me with dark eyes that missed nothing.

"That obvious?"

"You're standing at the bar like you're waiting for permission." He smiled, not unkindly. "I'm Klaus."

"James."

"American?"

"Yeah."

"Thought so. You look too clean." He gestured at my clothes. "You planning to keep those on all night?"

"I don't know what I'm planning."

"That's honest." He moved closer, close enough that I could smell him—leather and sweat and something darker. "You want to see the back rooms, James?"

My heart was hammering. "What's in the back rooms?"

"Everything you came here for." He tilted his head toward a doorway I hadn't noticed, half-hidden behind a curtain of chains. "But you have to be sure. Once you go down there, you can't unsee it. Can't unknow it."

I downed my second vodka. "I'm sure."

"Then follow me."

He led me through the curtain of chains and down a staircase. Each step took us deeper into the building, the music fading behind us, replaced by other sounds—moans, grunts, the wet slap of flesh on flesh. The walls were painted black, lit only by red LED strips that ran along the floor.

The corridor at the bottom was lined with doors. Some were closed. Some were open.

Klaus walked slowly, letting me look. Letting me understand what I'd walked into.

Through the first open door, I saw a man bent over a padded bench, wrists and ankles strapped down. Two others stood behind him, taking turns. The man on the bench was making sounds I'd never heard a human make—somewhere between pain and pleasure and something beyond both.

Through the second door, a man knelt in the center of a circle. Four men stood around him, and he moved from cock to cock, servicing each one with a dedication that bordered on worship. His own cock was hard and leaking, untouched.

Through the third door, a sling hung from the ceiling. The man in it was upside down, legs spread, while someone fucked him with a focus that was almost meditative. Others watched from the shadows, stroking themselves slowly.

My cock was painfully hard against my jeans. My mouth was dry. My heart was trying to escape my chest.

Klaus stopped at a door at the very end of the corridor. Unlike the others, this one was closed. He put his hand on the handle but didn't turn it yet.

"This room is special," he said, his voice low. "Friday night is comparison night. You understand what that means?"

I shook my head.

"It means we celebrate cock. All kinds. All sizes. We look, we touch, we compare, we worship. No judgment. Just appreciation." He studied my face. "Some men watch. Some men participate. Some men do both. What do you want to do, James?"

"I don't know."

"That's okay. You'll figure it out." He opened the door. "Come."

The room was larger than I expected. Maybe twenty feet square, with benches along the walls and a clear space in the center. The lighting was different here—brighter, more focused, designed to illuminate rather than hide.

A dozen men were scattered around the room. All ages, all body types. A bear in his fifties with a grey beard and a belly. A lean Asian guy who couldn't have been more than twenty-five. A muscled Black man with arms like a bodybuilder. A skinny twink with bleached hair. Regular guys who could have been accountants or teachers or mechanics.

In the center, two men stood facing each other, completely naked, completely hard. One had a thick, uncut cock that curved slightly to the left. The other was longer, cut, with prominent veins running along the shaft. They were stroking each other slowly, almost lazily, while the room watched.

"Beautiful," someone said from the shadows.

"Look at the way it curves."

"The foreskin on that one—perfect."

"Heavy balls. I bet he shoots a lot."

The commentary wasn't crude. It was reverent. These men were appreciating cock the way art critics appreciate paintings—noting details, expressing admiration, finding beauty in differences.

Klaus leaned close to my ear, his breath hot against my skin. "You can watch. You can join. You can get on your knees and worship every cock in this room if you want. No one will judge. That's the point."

I watched the two men in the center. Their hands moved faster now, their breathing becoming audible over the quiet murmur of the room. The thick one's balls were drawing up, his body tensing. The other man noticed, adjusted his grip, his thumb working over the sensitive head.

"He's close," someone observed.

"Watch his face."

The thick one grunted—a deep, animal sound—and came. His load shot across the other man's stomach in thick ropes, some of it reaching his chest. The room made sounds of approval, appreciation, almost awe.

"Beautiful."

"Look at that."

"He shoots far."

The second man followed moments later, adding his cum to the mess already coating his partner's skin. They stood there for a moment, breathing hard, still holding each other's softening cocks. Then they kissed—deep and filthy, tongues visible, sharing the taste of their own mouths—before stepping back to let the next pair take their place.

Klaus's hand was on my shoulder. "Your turn?"

My mouth was too dry to speak. My hands moved to my belt on instinct, fingers fumbling with the buckle. This was it. The moment I'd been building toward for three days. For longer than that, if I was honest. For years.

"Wait," Klaus said. He turned to the room. "We have a first-timer."

Every eye turned to me. I froze, my belt half-undone.

"American," Klaus continued. "Never been to a place like this. Never done anything like this." He looked at me. "Tell them what you want, James."

"I—" My voice cracked. I cleared my throat. "I want to stop being afraid."

The room was silent for a moment. Then the bear with the grey beard spoke up.

"Then take off your clothes and step into the light. We'll show you there's nothing to be afraid of."

My hands shook as I pulled my shirt over my head. I kicked off my shoes, pushed my jeans and briefs down together, stepped out of them. Naked in front of a room full of strangers, I'd never felt more exposed. But Klaus was right there, his hand steady on my back.

"Come," he said, guiding me to the center.

He was already naked—I hadn't even noticed him undress. His cock was thick and veined and fully hard, curving slightly upward. He reached for mine, wrapped his fingers around it, squeezed gently.

"Nice," he said, loud enough for the room to hear. "Good length. Cut. American cocks always look so clean."

Someone laughed—not mocking, just amused. I didn't care. Klaus's hand felt too good, and I was harder than I'd ever been in my life.

"Compare," someone called out.

Klaus pressed his cock against mine, held them together with one large hand. His was thicker, mine was longer. The difference was obvious, and the room began to discuss it like they were evaluating wine.

"The American has length."

"But Klaus has girth. Look at that thickness."

"Different beauty. Both perfect."

Then hands reached out from the watching men. Touching, measuring, feeling the weight of our balls, running fingers along our shafts. It should have felt invasive. Instead, it felt like worship.

"May I?" the bear asked, his hand hovering near my cock.

I nodded, unable to speak.

His palm was rough, calloused, warm. He wrapped it around me and stroked once, twice, his thumb rubbing over the head. I gasped.

"Sensitive," he observed with approval. "Good."

The Asian guy stepped forward next, comparing his own cock to mine—his was shorter but thicker, uncut, beautiful in its own way. We stood there, cocks touching, while the room watched and commented.

"Look at the contrast."

"Both perfect in different ways."

"I want to taste them both."

Klaus let this go on for several minutes—the touching, the comparing, the worship. Letting me understand that this wasn't about judgment or competition. It was about celebration. About men appreciating men without shame or pretense.

Then he dropped to his knees.

His mouth was hot and skilled, his tongue working the underside of my cock as he took me deeper. I watched my shaft disappear between his lips, watched his throat work as he swallowed around me. The room was silent except for the wet sounds of his mouth and my ragged breathing.

Then someone stepped up beside me. The younger guy—the lean one with bleached hair. He was hard, his cock jutting out from his slim hips, and Klaus reached for it without missing a beat on mine.

Klaus pulled off me with a wet pop, strings of spit connecting his lips to my cock. He turned to the young guy, took him deep in one smooth motion. The guy's head fell back, a moan escaping his throat.

"Fuck," he breathed. "His mouth is incredible."

Klaus alternated between us, taking turns, his hands working what his mouth wasn't on. The young guy looked at me, and there was something in his eyes—recognition, maybe. We were both being serviced by the same skilled mouth, both on display for the room, both giving ourselves over to this.

"Fuck his face," the young guy said to me, his voice rough. "He can take it. He wants it rough."

I looked down at Klaus. He pulled off the young guy's cock and looked up at me, his eyes dark and hungry. He nodded once.

I grabbed his head with both hands and drove into his throat. Hard. Fast. No mercy. His eyes watered immediately, spit running down his chin, but he didn't pull back. He opened wider, relaxed his throat, let me use him.

The room made sounds of appreciation.

"Look at him take it."

"Beautiful."

"The American's learning."

I fucked Klaus's face like I'd been doing it for years, like I wasn't a first-timer who'd been terrified an hour ago. The young guy beside me was stroking himself, watching, his other hand reaching out to touch my chest, my stomach, my ass.

Then I felt it—hands on me from behind. Someone spreading my cheeks, breath hot against my hole, and then a tongue. Pushing inside, wet and insistent and skilled.

My knees nearly buckled. I had to brace myself on Klaus's shoulders to stay upright. The tongue worked me open, licking and probing, while Klaus continued to take my cock down his throat. I was being worshipped from both ends, and the sensation was overwhelming.

"He's sensitive," someone observed from behind me. The bear, I realized. His voice was deep, amused. "Look at him shake."

A finger joined the tongue. Then two. Stretching me, preparing me, while Klaus pulled off my cock to let me breathe.

"Get him on all fours," someone said. "Let's really open him up."

Strong hands guided me down. I went willingly, past the point of hesitation or fear. Klaus positioned himself in front of me, his thick cock level with my face. I opened my mouth and he pushed in, feeding me slowly, letting me adjust to his girth.

The taste of him filled my mouth—salt and musk and something uniquely him. I sucked him like I was starving for it, which I was. I'd been starving for this my whole careful, controlled life, and now I was finally being fed.

Behind me, the bear's fingers worked deeper. Three now, scissoring, stretching. His other hand gripped my hip, steadying me.

"Good boy," he murmured. "You're opening up nice. You ready for cock?"

I pulled off Klaus long enough to gasp, "Yes. Please."

"Who wants him first?" the bear called to the room.

"I do." A new voice. I couldn't see who, but I felt him move into position behind me. The bear's fingers withdrew, and then there was the blunt pressure of a cockhead against my hole.

"Wait," I said, suddenly panicking. "Condom—"

"Testing station at the entrance," Klaus reminded me gently, his hand stroking my hair. "Everyone here is clean. Recent results posted. You saw them when you came in."

I had. I'd barely registered it at the time, but I remembered now—the wall of test results, all dated within the last two weeks. This place took care of its own.

"Okay," I breathed. "Okay."

The cock pushed in. Slowly at first, letting me adjust to the stretch, then deeper. Whoever it was was thick—not as thick as Klaus, but substantial. I groaned around Klaus's cock as I was filled from behind.

"There we go," the voice behind me said. The muscled Black guy, I realized. "Taking it so good. You were made for this."

He started to move. Long, slow strokes that made me feel every inch. Klaus held my head steady, fucking my mouth in counterpoint to the rhythm behind me. I was pinned between them, used from both ends, and it was exactly what I needed.

"Harder," I managed to say, pulling off Klaus's cock. Spit dripped from my lips. "Don't be gentle. I want to feel it."

"You sure?" the guy behind me asked.

"Wreck me."

He did. His hands gripped my hips hard enough to bruise, and he pounded into me with a force that drove me forward onto Klaus's cock. The slap of his hips against my ass echoed in the room. Klaus grabbed my hair, using my mouth, and I gave up trying to maintain any rhythm. All I could do was take it.

The room was watching. I could feel their eyes on me, hear their commentary.

"Look at him take it."

"He's a natural."

"First time, and he's already getting split open."

"Beautiful."

The praise, the attention, the raw physicality of it—it was too much. I came without anyone touching my cock. Just the fullness, the stretch, the overwhelming sensation of being used. I shot onto the floor beneath me, my ass clenching around the cock inside me, my whole body shaking.

"Fuck," the guy behind me grunted. I felt him swell, felt the pulse as he came inside me, felt the heat of his cum filling me up. He stayed buried deep for a moment, grinding against me, making sure I took every drop.

Then he pulled out. I felt empty, used, perfect.

"Who's next?" someone asked.

Before I could catch my breath, another cock was pushing into me. This one was longer, hitting deeper, and I gasped around Klaus's cock.

"That's it," Klaus murmured. "Take them all. You're doing so good."

I lost count after that. Lost track of who was fucking me, who was in my mouth, whose hands were on my body. The room became a blur of sensation—cocks and hands and mouths and cum.

The second guy was different—more deliberate, more controlled. He fucked me with long, measured strokes, his hands gripping my hips, pulling me back onto him with each thrust. Klaus had moved aside, and now the young guy with bleached hair was in front of me, his cock in my mouth.

"You're so fucking hot like this," he breathed, watching me take his cock while being fucked. "Taking it from both ends like you were born for it."

The third guy was rougher. He didn't ask, didn't ease in—just grabbed my hips and pounded into me like he owned me. I loved it. Loved the way he used me, the way he grunted with each thrust, the way he came inside me with a shout that made the whole room turn to watch.

By the time Klaus took his turn, I was already full of cum from three different men. His cock was the thickest, and I felt every inch as he pushed in, stretching me wider than I'd been all night.

"Breathe," he instructed, holding still, letting me adjust. "Just breathe and open for me."

I did. I relaxed, let him in, and when he started to move it was with a gentleness that surprised me. He fucked me slowly, deeply, his hands on my shoulders, his breath hot against my neck.

"You're perfect," he murmured. "So fucking perfect."

When he came, he stayed buried deep, his cock pulsing inside me, adding his load to the others. I felt full, used, claimed.

"On your back," someone said. "I want to see his face when he takes it."

Strong hands flipped me over. My legs were lifted, spread wide, held up by hands I couldn't see. The bear positioned himself between my legs, his cock thick and heavy, and pushed into me with one smooth thrust.

From this angle, I could see everything—his face as he fucked me, the room watching us, the other men stroking themselves. Someone straddled my face, and I opened my mouth automatically, letting him sit on me, his ass pressing down as I ate him out.

I was completely pinned, completely used, and it was overwhelming. The bear fucked me with steady, powerful strokes while I tongued the hole above me. My own cock was hard again, leaking onto my stomach, and when someone's hand wrapped around it and started stroking, I knew I was going to come again.

"He's close," someone observed. "Look at his cock."

"Make him come while he's being bred."

"Fill him up."

The hand on my cock moved faster. The bear's thrusts became erratic, harder. The guy on my face ground down, using my tongue. It was too much—all of it was too much—and I came with a broken sound, my cum shooting across my chest and stomach while the bear groaned and emptied himself inside me.

The night became a fever dream after that. I lost track of time, of who was doing what to me. At one point I was in the middle of a chain—the Asian guy fucking me while I fucked the young twink, all of us connected, moving together. Hands roamed everywhere, mouths found whatever skin they could reach, and I gave myself over to it completely.

I tasted what felt like a dozen different men. Some were gentle, some were rough. Some wanted to be worshipped, others wanted to worship. I did it all—sucked, fucked, got fucked, ate ass, had my ass eaten. I was passed around the room like a gift, and I loved every second of it.

When it finally ended—three, maybe four in the morning—I was completely wrecked. Cum dried on my skin and leaked out of my hole. My throat was raw from being fucked. My body was covered in bruises and bite marks and scratches. I couldn't remember the last time I'd felt this used, this satisfied, this free.

Klaus found me slumped against the wall, barely able to keep my eyes open.

"You did well," he said. "For a first time."

I laughed weakly. "I'll never walk right again."

"That's the goal." He helped me up, led me to a shower room where I stood under hot water and watched the evidence of the night run down the drain.

Outside, Berlin was grey and cold and beginning to wake up. I walked back toward my hotel with that particular ache that comes from being thoroughly used, feeling lighter than I had in years.

I'd wanted to lose myself, and I had. In that basement room, I'd been nothing but a body, nothing but desire, nothing but holes to be filled and hands to grab and a mouth to be used. No name, no job, no history. Just animal need, finally freed.

I went back twice more that weekend. By Sunday, I could barely sit on the plane home. But I was smiling the whole flight.

Some cities give you culture, history, art. Berlin gave me the most honest night of my life—a room full of strangers who wanted exactly what I wanted, no pretense, no shame. Just bodies finding bodies in the dark.

That's all it ever needs to be.`
};
